<div id="top" class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Créditer mon compte</div>
</div>
<div class="row w-100">
    <div class="row w-100 pt-3">
        <p> En créditant votre compte vous anticipez le paiement de vos prochaines factures. La somme versée sera
            utilisée pour régler celles-ci. </p>
        @if (step == 1) {
            <div class="form-group pb-2 pt-2">
                <span class="bold-label-text float-left">Montant à créditer ( 1€ min, {{ maxAmount }}€ max ):</span>
                <input class="form-control ng-pristine ng-valid ng-touched" id="amount" placeholder="1"
                       [(ngModel)]="paymentDetailsInterface.amount" type="number">
                @if (invalidAmount) {
                    <p class="error-message">Veuillez entrer un montant entre 1€ et {{ maxAmount }}€.</p>
                }
            </div>
        }
        @if (step == 2) {
            <div class="form-group pb-2 pt-2">
                <span class="bold-label-text float-left">Montant à créditer : </span><span
                    class="pl-2">{{ paymentDetailsInterface.amount }}€</span>
            </div>
        }
        @if (step == 1) {
            <div class="row w-100 pt-3 text-center">
                <div class="col-12 w-100 cta_container">
                    <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                    <button type="button" class="cta_btn level_2 column" (click)="setStep(2)">Suivant<span></span>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
<div class="w-100">
    @if (step == 2) {
        <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
    }
</div>
